import createCache from '@emotion/cache'

// Create an Emotion cache that includes a nonce and proper SSR settings
const createEmotionCache = (nonce: string | undefined) => {
  return createCache({
    key: 'css',
    nonce, // Add the nonce here
    prepend: true, // Ensures Material-UI styles come first
  })
}

export default createEmotionCache
